import { createCardPRVerbose } from '@lc/interface/card/pr/factory';
import { PR } from '@lc/interface/card/pr/types';

export const getPRVerbose = (PRMeta: PR[]) => [
	createCardPRVerbose(PRMeta[0]), // 121
	createCardPRVerbose(PRMeta[1]), // 122
	createCardPRVerbose(PRMeta[2]), // 123
	createCardPRVerbose(PRMeta[3]), // 124
	createCardPRVerbose(PRMeta[4]), // 125
	createCardPRVerbose(PRMeta[5]), // 126
	createCardPRVerbose(PRMeta[5]), // 127
	createCardPRVerbose(PRMeta[6]), // 128
	createCardPRVerbose(PRMeta[7]), // 129
	createCardPRVerbose(PRMeta[8]), // 130
	createCardPRVerbose(PRMeta[9]), // 131
	createCardPRVerbose(PRMeta[10]), // 132
];
